import {
	drawPointsAnim,
	drawLineAnim,
	drawCircleAnim,
	rotateCircleAnim,
	addCustomDelay
} from "../../../../../../src/animation/Circle/helpers/drawHelpers";
import { INITIAL_RADIANS } from "../../types/Config";
import { normalizeRadian } from "../../../../../../src/utils/math/normalizeRadian";
import { ContextType } from "../../types/Interface";


export async function runCircleAnimation(context:ContextType, onComp: () => void) {
	const {
		circle,
		LineManager,
		PointManager,
		cCoord,
	} = context;

	const centerPoint = PointManager.getPoints()[0];
	const chordCoordsArr = PointManager.getInitialChordsCoords();
	const intersecCoord = PointManager.getInitialIntersecCoord(chordCoordsArr);
	const RedPoints = PointManager.getRedPoints();
	const initialRadian = PointManager.getInitialRadians();


	circle.setRadians([INITIAL_RADIANS[0], INITIAL_RADIANS[0]]);

	drawPointsAnim([centerPoint]);
	await drawCircleAnim(circle, INITIAL_RADIANS[0] + Math.PI * 2, 0, true, cCoord);

	await drawLineAnim(LineManager.helperLines[0], chordCoordsArr[0][0], chordCoordsArr[1][0]);
	await drawLineAnim(LineManager.helperLines[1], chordCoordsArr[0][2], chordCoordsArr[1][2]);
	await addCustomDelay(1000);

	await drawLineAnim(LineManager.lines[0], intersecCoord, chordCoordsArr[0][0]);
	await drawLineAnim(LineManager.lines[2], intersecCoord, chordCoordsArr[1][0]);
	await drawLineAnim(LineManager.lines[1], intersecCoord, chordCoordsArr[0][2]);
	await drawLineAnim(LineManager.lines[3], intersecCoord, chordCoordsArr[1][2]);

	LineManager.helperLines.forEach(l => l.clear());

	await rotateCircleAnim((v) => PointManager.setRadian(Array(2).fill("").map(((_, rI) => ({ pTag: RedPoints[rI].tag, radian: normalizeRadian(initialRadian[rI] + v) })))));

	onComp();
}